export const defaultUserStaticMetadata = {
    premium: false,
    premium_status: 'NONE',
    premium_expiration_at_ms: null,
    premium_last_event_ms: 0,
    max_cards: 50,
    cards_per_day: 5,
    thanks_trial: 'none',
    management_url: null,
};
export const mergeUserStaticMetadata = (md1, md2) => {
    return {
        ...md1,
        ...md2,
    };
};
export const mapUserStaticMetadata = (metadata) => {
    return mergeUserStaticMetadata(defaultUserStaticMetadata, metadata);
};
